
import { getDrafts, deleteDrafts } from '@/api';
import Header from '@/components/jobBooking/Header/Header.vue';
import BackButton from '@/components/UI/backButton/BackButton.vue';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { User } from '@/models/main';
import { JobDraftsListItem, DraftsRequestData, DraftsResponseData } from '@/models/draft';
import { mapState } from 'vuex';
import { notificationErrorText } from '@/utils/PortalConstants';
import { formatDateStringWithTZ } from '@/utils/InputProcessingUtilities';

@Component({
  components: {
    BackButton,
    Header,
  },
  computed: {
    ...mapState('moduleUser', { user: 'user' }),
  },
})
export default class Drafts extends Vue {
  private loading = false;
  private user!: User;
  // to use func in the template
  private formatDateStringWithTZ = formatDateStringWithTZ;
  private drafts: JobDraftsListItem[] = [];

  private headers = [
    { text: 'Id', value: 'id', align: 'left' },
    { text: 'Name', value: 'name', align: 'left' },
    { text: 'Created by', value: 'created_by', align: 'left' },
    { text: 'Modified date', value: 'modified', align: 'left' },
    { text: 'Created date', value: 'created', align: 'left' },
    { text: 'Edit', align: 'start', sortable: false, value: 'edit' },
    { text: 'Delete', align: 'start', sortable: false, value: 'delete' },
  ];

  private pageData: DraftsResponseData = {
    count: 0,
    next: '',
    previous: '',
    results: [],
  };

  private pagination = {
    page: 1,
    current: 1,
    total: 0,
    perPage: '10',
    visible: 7,
    perPageOptions: ['1', '5', '10', '50', '100'],
  };

  private async updatePagination() {
    await this.getDraftsWrapper();
    // Pagination corrections:
    this.pagination.total = Math.ceil(this.pageData.count / Number(this.pagination.perPage));
    if (this.pagination.current === 0 && this.pagination.total >= 1) {
      this.pagination.current = 1;
    }
    if (this.pagination.current > this.pagination.total) {
      this.pagination.current = this.pagination.total;
    }
  }

  @Watch('pagination.perPage')
  private perPageSelectChanged() {
    this.pagination.current = 1;
    this.updatePagination();
  }

  private editItem(id): void {
    this.$router.push({ path: `/jobbooking/advanced/draft/${id}` });
  }

  private deleteItem(id): void {
    const showError = () =>
      this.$notify({
        group: 'network',
        title: 'Error deleting the draft',
        text: notificationErrorText,
        type: 'warn',
      });
    deleteDrafts(id)
      .then(res => {
        if (res.status === 204) {
          const deletingItemIndex = this.drafts.findIndex(item => item.id === id);
          this.drafts.splice(deletingItemIndex, 1);
          this.pagination.current = 1;
          this.getDraftsWrapper();
        } else {
          showError();
        }
      })
      .catch(() => {
        showError();
      });
  }

  private async getDraftsWrapper() {
    this.loading = true;
    const endpointParams: DraftsRequestData = {
      page: this.pagination.current,
      page_size: Number(this.pagination.perPage),
    };
    await getDrafts(endpointParams)
      .then((data: DraftsResponseData) => {
        this.pageData = data;
        this.drafts = data.results;
        this.pagination.total = Math.ceil(this.pageData.count / Number(this.pagination.perPage));
      })
      .catch(() => {
        this.$notify({
          group: 'network',
          // check
          title: 'Error loading drafts',
          text: notificationErrorText,
          type: 'warn',
        });
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private mounted(): void {
    this.getDraftsWrapper();
  }
}
